/* unplugin-vue-components disabled */import { render } from "./home.vue?vue&type=template&id=56449af0&scoped=true"
import script from "./home.vue?vue&type=script&lang=js"
export * from "./home.vue?vue&type=script&lang=js"

import "./home.vue?vue&type=style&index=0&id=56449af0&scoped=true&lang=less"

import exportComponent from "/Users/yfy/work/work/cms-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56449af0"]])

export default __exports__